// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_XHf5c","morehNew":"index_morehNew_P1WAu","more":"index_more_IqD5Q"};